<header id="app-header">
	<div id="app-branding">
		<div id="app-icon">
			<img src="assets/image/FordOval.png" class="logo" alt="Ford Oval" />
		</div>
		<div id="app-name">
			<h1><a routerLink="/documents-search">Ford FisDealer</a></h1>
		</div>

		<div id="app-login">
			<a class="p-grid-4 profile">
				<div class="avatar-profile">
					<img alt="avatar" src="data:image/jpeg;base64,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">
				</div>
				<div class="user-profile">
					<div>
						<div class="text-left">{{user?.userName}}</div>
						<div class="text-left" *ngIf="user !== null">({{dealer?.code}})</div>
					</div>
					<span class="fas fa-caret-down"></span>
				</div>
			</a>
			<div class="profile-box">
				<ul class="profile-menu">
					<li class="profile-item-text">Bienvenido<br/>{{user?.displayName}}</li>
					<li class="profile-item" *ngIf="user !== null">
						<a (click)="showDealerToggle()">Concesionario: {{dealer?.code}}</a>
					</li>
					<li class="profile-item">
						<a (click)="logout()">Salir</a>
					</li>
				</ul>
			</div>
		</div>

		<!-- <div class="btn-sidebar">
			<button (click)="hamMenu = true" pButton class="mobile-menu">
				<i class="fa fa-bars"></i>
			</button>
		</div> -->
	</div>


	<!-- desktop menu bar -->
	<p-menubar [model]="navMenuItems" styleClass="p-menubar">
		<!-- <div class="sidebar-app-login" *ngIf="user !== null">
			<a><i class="fa fa-user-circle-o"></i>{{user?.displayName}}</a>
			<a (click)="showDealerToggle()" *ngIf="user !== null">Concesionario: {{dealer?.code}}</a>
			<a (click)="logout()">Salir</a>
		</div> -->
	</p-menubar>

	<!-- mobile menu bar -->
	<!-- <p-sidebar [(visible)]="hamMenu" position="right" [modal]="true">
		<p-menubar [model]="navMenuItems">
			<div class="sidebar-app-login" *ngIf="user !== null">
				<a><i class="fa fa-user-circle-o"></i>{{user?.displayName}}</a>
				<a (click)="showDealerToggle()" *ngIf="user !== null">Concesionario: {{dealer?.code}}</a>
				<a (click)="logout()">Salir</a>
			</div>
		</p-menubar>
	</p-sidebar> -->

	<!-- select client modal -->
	<p-dialog [(visible)]="display" *ngIf="user !== null" [modal]="true" [contentStyle]="{'min-height':'300px', 'min-width':'350px'}">

		<ng-template pTemplate="header">
			Seleccionar Concesionario:
		</ng-template>

		<div class="p-grid">
			<p-listbox [options]="dealers" [(ngModel)]="selectedDealer" optionLabel="code">
				<ng-template let-item pTemplate="selectedItem">
					<span>{{item?.code}} - {{item?.country}} - {{item?.description}}</span>
				</ng-template>
			</p-listbox>
		</div>

		<ng-template pTemplate="footer">
			<button type="button" pButton (click)="changeDealer();display=false;" label="Establecer" class="p-button-success"></button>
			<button type="button" pButton (click)="display=false;" label="Cancelar" class="p-button-secondary"></button>
		</ng-template>
	</p-dialog>

</header>
